var React = require('react');

function CheckedPositive (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M15.5,305.4c0-5.6,0-11.2,0-16.8c1.3-0.4,1-1.7,1.2-2.6c2.4-10.1,7.3-18.9,15-25.9c23.2-21.4,57.9-18.8,79.4,6\n\t\tc21.5,24.9,42.9,50,64.3,75c6,7,10.1,7.1,16.3,0.4c57.4-62.6,114.9-125.3,172.3-187.9c32.8-35.8,65.6-71.6,98.4-107.3\n\t\tc14.4-15.7,32-22,52.6-15.4c20.9,6.7,33.1,21.9,38,43.1c0.3,1.1-0.4,2.5,1.1,3.2c0,5.3,0,10.5,0,15.8c-3.3,8.5-6.2,17.1-11.6,24.8\n\t\tc-89.9,129.7-179.7,259.4-269.4,389.1c-14.5,21-34,32.2-59.7,33.8c-22.8,1.4-39.9-5.5-53.2-25.1c-25.9-38.1-53.9-74.7-79.9-112.8\n\t\tC58.4,370.6,31.2,341.8,15.5,305.4z","fill":"#232A52"})));
}

CheckedPositive.defaultProps = {"version":"1.1","id":"Warstwa_1","width":"20","height":"20","x":"0px","y":"0px","viewBox":"0 0 566.9 566.9","style":{"enableBackground":"new 0 0 566.9 566.9"},"xmlSpace":"preserve"};

module.exports = CheckedPositive;

CheckedPositive.default = CheckedPositive;
